import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    // console.log(window.scrollX, window.scrollY);
    // console.log(window.scrollX, window.scrollY);
    // console.log(window.scrollX, window.scrollY);
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return null;
};

export default ScrollToTop;
